import { Layout } from '@/components/Layout';
import { Mail } from 'lucide-react';
import { FaXTwitter, FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa6';

export default function Contact() {
  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12 max-w-4xl" data-testid="contact-page">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8">CONTACT US</h1>
        
        <div className="space-y-8">
          <div>
            <p className="text-lg text-muted-foreground mb-6">
              Have questions about our analysis? Want to discuss partnerships? Reach out to us through any of the channels below.
            </p>
          </div>

          <div className="bg-card border border-border p-8">
            <h2 className="text-2xl font-heading font-bold mb-6">EMAIL</h2>
            <a 
              href="mailto:primestatlab@gmail.com" 
              className="flex items-center gap-3 text-primary hover:underline text-xl"
              data-testid="contact-email"
            >
              <Mail size={24} />
              primestatlab@gmail.com
            </a>
          </div>

          <div className="bg-card border border-border p-8">
            <h2 className="text-2xl font-heading font-bold mb-6">SOCIAL MEDIA</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <a
                href="https://x.com/primestatlab"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                data-testid="contact-twitter"
              >
                <FaXTwitter size={24} />
                <span>@primestatlab</span>
              </a>
              <a
                href="https://instagram.com/primestatlab/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                data-testid="contact-instagram"
              >
                <FaInstagram size={24} />
                <span>@primestatlab</span>
              </a>
              <a
                href="https://www.youtube.com/@primestatlab"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                data-testid="contact-youtube"
              >
                <FaYoutube size={24} />
                <span>@primestatlab</span>
              </a>
              <a
                href="https://www.tiktok.com/@primestatlab"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-foreground hover:text-primary transition-colors"
                data-testid="contact-tiktok"
              >
                <FaTiktok size={24} />
                <span>@primestatlab</span>
              </a>
            </div>
          </div>

          <div className="bg-card border border-border p-8">
            <h2 className="text-2xl font-heading font-bold mb-4">BUSINESS HOURS</h2>
            <p className="text-muted-foreground">
              We typically respond within 24-48 hours during the sports season. For urgent inquiries, please reach out via social media DM.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}